/* tslint:disable:indent */
import {DisplayTypeEnum, isField, isFieldOrGroup, isGroup, isSectionWithNoSection} from '../enum/display-type.enum';
import {NoticeTypesEnum} from '../enum/notice-types.enum';
import {NoticeFactory} from '../model/factories/notice.factory';
import {Group} from '../model/group';
import {Notice} from '../model/notice';
import {Section} from '../model/section';
import {SubGroup} from '../model/sub-group';
import {SubSection} from '../model/sub-section';
import {SubSubGroup} from '../model/sub-sub-group';
import {EnumToolsService} from './enum.tools.service';
import {LogService} from '../../../shared/services/log.service';
import {SubSubSubGroup} from '../model/sub-sub-sub-group';
import {SubSubSubSubGroup} from '../model/sub-sub-sub-sub-group';
import {EFormsOrgService} from './e-forms-org.service';

export class EFormsSdkService {

  private static LOG: LogService = new LogService(EFormsSdkService);

  constructor() {
  }


  /**
   *
   */
  public static getNotice(noticeType: NoticeTypesEnum, noticeObject: any, eFormsOrgService: EFormsOrgService): Notice {

    let fieldId;
    let currentGroupId;
    // préparer l'objet notice
    const notice: Notice = NoticeFactory.createNotice();
    // traiter les metadata
    const metaDataFromJson = noticeObject.metadata;
    // tslint:disable-next-line:forin
    for (fieldId in Object.keys(metaDataFromJson)) {
      notice.metadata.fields.push(NoticeFactory.createField(metaDataFromJson[fieldId]));
    }
    // traiter les sections
    const sections = noticeObject.content;
    let sectionNumber = 0;

    for (const sectionId in Object.keys(sections)) {
      const currentSection = sections[sectionId];
      sectionNumber++;
      this.LOG.debug(`${noticeType}  | [SECTION ${sectionNumber} ] :${currentSection.id}`);

      if (currentSection.displayType !== DisplayTypeEnum[DisplayTypeEnum.SECTION]) {
        // le premier niveau des sections ne continet que des sections
        throw new Error(`${noticeType} | Element ${currentSection.displayType} non attendu : SECTION est attendu`);
      } else {
        currentSection.index = sectionNumber;
        // avancer afin de traiter les sections
        const section: Section = NoticeFactory.createSection(currentSection);
        const sectionContent = currentSection.content;
        let subSectionNumber = 0;
        let groupNumber = 0;
        const fieldnNumber = 0;
        for (const elementsectionNumber in Object.keys(sectionContent)) {
          // dans chaque boucle il faut récupérer l'object en cours
          const currentSectionElement = sectionContent[elementsectionNumber];

          if (!EnumToolsService.enumContainsString(DisplayTypeEnum, currentSectionElement.displayType)) {
            // la section du premier niveau peut contenir à la fois des group des sections(subsection) et des fields
            // vérifier qu'il n y pas un nouveau type de composant est présent
            throw new Error(`${noticeType}  | Element ${currentSectionElement.displayType} non attendu : ${EnumToolsService.getValues(DisplayTypeEnum)} est attendu`);
          } else {
            // le cas des sections du premeier niveau
            if (currentSectionElement.displayType === DisplayTypeEnum[DisplayTypeEnum.SECTION]) {
              // l'objet en cours est une section ( donc une subSection)
              subSectionNumber++;
              this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} ] : ${currentSectionElement.id}`);
              // dans le cas d'une sub section
              const sectionSubsection: SubSection = NoticeFactory.createSubSection(currentSectionElement);
              // ajouter les subSection dans la section
              section.subsections.push(sectionSubsection);
              // parcourir aussi les elements de la sub section
              const subSectionContent = currentSectionElement.content;
              let sectionSubsectionGroupNumber = 0;
              let sectionSubsectionFieldNumber = 0;

              for (const subSectionId in Object.keys(subSectionContent)) {
                const currentSubSections = subSectionContent[subSectionId];
                if (!isFieldOrGroup(currentSubSections.displayType) && !isSectionWithNoSection(currentSubSections)) {
                  // TODO : à corriger pour E_FORM_16 ; E_FORM_25 ; E_FORM_29 ; E_FORM_38
                  // activer l'exception
                  // analyser le pb
                  // faire le correctif nécéssaire pour créer une section dans une autre
                  // pour cela il faut modifier le model
                  // et surtout le composant
                  // voir si c'est possible d'ajouter cet élément dans les subSections
                  throw new Error(`${noticeType}  | Dans le cas d' une sub section : Element ${currentSubSections.displayType} non attendu :(GROUP | FIELD) est attendu`);
                } else {
                  if (currentSubSections.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP] ||
                    currentSubSections.displayType === DisplayTypeEnum[DisplayTypeEnum.SECTION]) {
                    sectionSubsectionGroupNumber++;
                    this.LOG.debug(`${noticeType} [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} ] :  currentSubSections.id`);
                    const sectionSubSectiongroup: Group = NoticeFactory.createGroup(currentSubSections);
                    sectionSubsection.groups.push(sectionSubSectiongroup);
                    // parcourir aussi les elements du group
                    const fields = currentSubSections.content;

                    let sectionSubSectionGroupSubGroupNumber = 0;
                    let sectionSubSectionGroupFieldNumber = 0;
                    for (fieldId in Object.keys(fields)) {
                      const currentField = fields[fieldId];
                      // un group ne contient que des fields
                      if (!isFieldOrGroup(currentField.displayType)) {
                        throw new Error(`${noticeType} | Dans le cas d'un group dans une subsection : Element ${currentField.displayType} non attendu :(GROUP|FIELD) est attendu`);
                      } else {

                        if (currentField.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
                          sectionSubSectionGroupSubGroupNumber++;
                          this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | SUB_GROUP ${sectionSubSectionGroupSubGroupNumber} ] : ${currentField.id}`);
                          const sectionSubSectionGroupSubgroup: SubGroup = NoticeFactory.createSubGroup(currentField);
                          sectionSubSectiongroup.subGroups.push(sectionSubSectionGroupSubgroup);
                          // ce sub groupe ne doit contenir que des Fields

                          const currentsSubGroupFields = currentField.content;
                          let sectionSubSectionGroupSubGroupSubSubGroupNumber = 0;

                          for (currentGroupId in Object.keys(currentsSubGroupFields)) {
                            const currentsSubGroupField = currentsSubGroupFields[currentGroupId];
                            if (!isFieldOrGroup(currentsSubGroupField.displayType)) {
                              if("SECTION" === currentsSubGroupField.displayType){
                                currentsSubGroupField.displayType = "GROUP";
                              }else{
                                throw new Error(`${noticeType} | Element ${currentsSubGroupField.displayType} non attendu :(GROUP|FIELD|SECTION) est attendu`);
                              }
                            }

                            if (currentsSubGroupField.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {

                              const subSubgroup: SubSubGroup = NoticeFactory.createSubSubgroup(currentsSubGroupField);
                              sectionSubSectionGroupSubgroup.subSubGroups.push(subSubgroup);
                              sectionSubSectionGroupSubGroupSubSubGroupNumber++;
                              this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | SUB_GROUP
                                  ${sectionSubSectionGroupSubGroupNumber} | SUB_SUB_GROUP ${sectionSubSectionGroupSubGroupSubSubGroupNumber} ] : ${currentsSubGroupField.id}`);

                              let sectionSubSectionGroupSubGroupSubSubGroupFieldNumber = 0;
                              const currentsSubSubGroupField = currentsSubGroupField.content;
                              // tslint:disable-next-line:forin
                              currentsSubSubGroupField.forEach(element => {
                                if (element.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
                                  const subSubSubGroup: SubSubSubGroup = NoticeFactory.createSubSubSubgroup(element);
                                  element.content.forEach(ctt => {
                                    if (!isField(ctt.displayType)) {
                                      if (ctt.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
                                        //sub sub sub sub group ....
                                        const subSubSubSubGroup: SubSubSubSubGroup = NoticeFactory.createSubSubSubSubgroup(ctt);
                                        ctt.content.forEach(subsubsubsubfield => {
                                          if (!isField(subsubsubsubfield.displayType)) {
                                            throw new Error(`${noticeType} ${sectionNumber} | Element ${subsubsubsubfield.displayType} non attendu :(FIELD) est attendu`);
                                          } else {
                                            subSubSubSubGroup.fields.push(NoticeFactory.createField(subsubsubsubfield));
                                          }
                                        });
                                        subSubSubGroup.subSubSubSubGroup.push(subSubSubSubGroup);
                                      } else {
                                        throw new Error(`${noticeType} ${sectionNumber} | Element ${ctt.displayType} non attendu :(FIELD) est attendu`);
                                      }
                                    } else {
                                      subSubSubGroup.fields.push(NoticeFactory.createField(ctt));
                                    }
                                  });
                                  subSubgroup.subSubSubGroup.push(subSubSubGroup);
                                } else {
                                  subSubgroup.fields.push(NoticeFactory.createField(element));
                                }
                              });
                            } else {
                              if (!isField(currentsSubGroupField.displayType)) {
                                throw new Error(`${noticeType}   ${sectionNumber} | Element  ${currentsSubGroupField.displayType}  non attendu :(GROUP|FIELD) est attendu`);
                              }
                              // ceci est un field
                              this.LOG.debug(`${noticeType}  | [SECTION  ${sectionNumber} | SUB_SECTION
                                  ${subSectionNumber} | GROUP  ${sectionSubsectionGroupNumber} | SUB_GROUP
                                  ${sectionSubSectionGroupSubGroupNumber} | FIELD] :  ${currentsSubGroupField.id}`);
                              sectionSubSectionGroupSubgroup.fields.push(NoticeFactory.createField(currentsSubGroupField));

                            }


                          }
                        } else if (isField(currentField.displayType)) {
                          sectionSubSectionGroupFieldNumber++;
                          if (currentField.id == "OPT-301-Lot-ReviewOrg" && currentField.mandatory.includes(noticeType.toString().slice(-2)))
                            eFormsOrgService.setNeedSecondOrganization(true);
                          this.LOG.debug(`${noticeType}  | [SECTION  ${sectionNumber} | SUB_SECTION  ${subSectionNumber} | GROUP  ${sectionSubsectionGroupNumber}  | FIELD  ${sectionSubSectionGroupFieldNumber} ] :  ${currentField.id}`);
                          sectionSubSectiongroup.fields.push(NoticeFactory.createField(currentField));
                        }
                      }
                    }
                  } else {
                    sectionSubsectionFieldNumber++;
                    this.LOG.debug(`${noticeType}  | [SECTION  ${sectionNumber} | SUB_SECTION  ${subSectionNumber} | FIELD  ${sectionSubsectionFieldNumber} ] :  ${currentSubSections.id}`);
                    sectionSubsection.fields.push(NoticeFactory.createField(currentSubSections));
                  }
                }
              }
            } else if (currentSectionElement.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP] && currentSectionElement.content?.length > 0) {
              // l'objet en cours est un groupe ( donc une subGroup )
              subSectionNumber++;
              this.LOG.debug(`${noticeType}  | [SECTION  ${sectionNumber} | SUB_SECTION  ${subSectionNumber} ] :  ${currentSectionElement.id}`);
              // dans le cas d'un subgroup
              const sectionSubsection: SubSection = NoticeFactory.createSubSection(currentSectionElement);
              // ajouter les subgroup dans la section
              section.subsections.push(sectionSubsection);
              // parcourir aussi les elements de la subgroup
              const subSectionContent = currentSectionElement.content;
              let sectionSubsectionGroupNumber = 0;
              let sectionSubsectionFieldNumber = 0;

              for (const subSectionId in Object.keys(subSectionContent)) {
                const currentSubSections = subSectionContent[subSectionId];
                if (!isFieldOrGroup(currentSubSections.displayType)) {
                  throw new Error(`${noticeType}  | Dans le cas d' une sub section : Element  ${currentSubSections.displayType}  non attendu :(GROUP | FIELD) est attendu`);
                } else {
                  if (currentSubSections.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
                    sectionSubsectionGroupNumber++;
                    this.LOG.debug(`${noticeType}  | [SECTION  ${sectionNumber} | SUB_SECTION  ${subSectionNumber} | GROUP  ${sectionSubsectionGroupNumber} ] ${currentSubSections.id}`);
                    const sectionSubSectiongroup: Group = NoticeFactory.createGroup(currentSubSections);
                    sectionSubsection.groups.push(sectionSubSectiongroup);
                    // parcourir aussi les elements du group
                    const fields = currentSubSections.content;

                    let sectionSubSectionGroupSubGroupNumber = 0;
                    let sectionSubSectionGroupFieldNumber = 0;
                    for (fieldId in Object.keys(fields)) {
                      const currentField = fields[fieldId];
                      // un group ne contient que des fields
                      if (!isFieldOrGroup(currentField.displayType)) {
                        throw new Error(`${noticeType}  | Dans le cas d'un group dans une subsection : Element  ${currentField.displayType}  non attendu :(GROUP|FIELD) est attendu`);
                      } else {

                        if (currentField.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
                          sectionSubSectionGroupSubGroupNumber++;
                          this.LOG.debug(`${noticeType} | [SECTION  ${sectionNumber} | SUB_SECTION  ${subSectionNumber} | GROUP  ${sectionSubsectionGroupNumber} | SUB_GROUP  ${sectionSubSectionGroupSubGroupNumber} ] :  ${currentField.id}`);
                          const sectionSubSectionGroupSubgroup: SubGroup = NoticeFactory.createSubGroup(currentField);
                          sectionSubSectiongroup.subGroups.push(sectionSubSectionGroupSubgroup);
                          // ce sub groupe ne doit contenir que des Fields

                          const currentsSubGroupFields = currentField.content;
                          let sectionSubSectionGroupSubGroupSubSubGroupNumber = 0;

                          for (currentGroupId in Object.keys(currentsSubGroupFields)) {
                            const currentsSubGroupField = currentsSubGroupFields[currentGroupId];
                            // un group ne doit contenir que des fields
                            if (!isFieldOrGroup(currentsSubGroupField.displayType)) {
                              throw new Error(`${noticeType} | Element ${currentsSubGroupField.displayType} non attendu :(GROUP|FIELD) est attendu`);
                            } else {

                              if (currentsSubGroupField.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {

                                const subSubgroup: SubSubGroup = NoticeFactory.createSubSubgroup(currentsSubGroupField);
                                sectionSubSectionGroupSubgroup.subSubGroups.push(subSubgroup);
                                sectionSubSectionGroupSubGroupSubSubGroupNumber++;
                                this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION
                                  ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | SUB_GROUP
                                  ${sectionSubSectionGroupSubGroupNumber} | SUB_SUB_GROUP  ${sectionSubSectionGroupSubGroupSubSubGroupNumber} ] :  ${currentsSubGroupField.id}`);

                                let sectionSubSectionGroupSubGroupSubSubGroupFieldNumber = 0;
                                const currentsSubSubGroupField = currentsSubGroupField.content;
                                // tslint:disable-next-line:forin
                                for (const currentsSubSubGroupFieldId in Object.keys(currentsSubSubGroupField)) {
                                  const currentSubSubGroupField = currentsSubSubGroupField[currentsSubSubGroupFieldId];

                                  // un group ne doit contenir que des fields
                                  if (!isField(currentSubSubGroupField.displayType)) {
                                    throw new Error(`${noticeType} ${sectionNumber} | Element ${currentSubSubGroupField.displayType} non attendu :(GROUP|FIELD) est attendu`);
                                  }
                                  sectionSubSectionGroupSubGroupSubSubGroupFieldNumber++;
                                  this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | SUB_GROUP ${sectionSubSectionGroupSubGroupNumber} | SUB_SUB_GROUP ${sectionSubSectionGroupSubGroupSubSubGroupNumber} | FIELD ${sectionSubSectionGroupSubGroupSubSubGroupFieldNumber} ] : ${currentSubSubGroupField.id}`);
                                  subSubgroup.fields.push(NoticeFactory.createField(currentSubSubGroupField));
                                }
                              } else {
                                if (!isField(currentsSubGroupField.displayType)) {
                                  throw new Error(`${noticeType} ${sectionNumber}  | Element ${currentsSubGroupField.displayType} non attendu :(GROUP|FIELD) est attendu`);
                                }
                                // ceci est un field
                                this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION
                                  ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | SUB_GROUP
                                  ${sectionSubSectionGroupSubGroupNumber} | FIELD] : ${currentsSubGroupField.id}`);
                                sectionSubSectionGroupSubgroup.fields.push(NoticeFactory.createField(currentsSubGroupField));

                              }
                            }

                          }
                        } else if (isField(currentField.displayType)) {
                          sectionSubSectionGroupFieldNumber++;
                          this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | GROUP ${sectionSubsectionGroupNumber} | FIELD ${sectionSubSectionGroupFieldNumber} ] : ${currentField.id}`);
                          sectionSubSectiongroup.fields.push(NoticeFactory.createField(currentField));
                        }
                      }
                    }
                  } else {
                    sectionSubsectionFieldNumber++;
                    this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | SUB_SECTION ${subSectionNumber} | FIELD ${sectionSubsectionFieldNumber} ] : ${currentSubSections.id}`);
                    sectionSubsection.fields.push(NoticeFactory.createField(currentSubSections));
                  }
                }
              }
            } else if (currentSectionElement.displayType === DisplayTypeEnum[DisplayTypeEnum.GROUP]) {
              // le group du premier niveau ne contient que des fields
              // OK
              groupNumber++;
              this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | GROUP ${groupNumber} ] : ${currentSectionElement.id}`);
              // dans le cas d'une group
              const sectionGroup: Group = NoticeFactory.createGroup(currentSectionElement);
              // parcourir aussi les elements du group
              const currentsGroup = currentSectionElement.content;
              let sectionGroupFieldNumber = 0;
              // tslint:disable-next-line:forin
              for (currentGroupId in Object.keys(currentsGroup)) {
                const currentField = currentsGroup[currentGroupId];
                sectionGroupFieldNumber++;
                this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | GROUP ${groupNumber} | FIELD ${sectionGroupFieldNumber}] : ${currentField.id}`);
                // un group ne doit contenir que des fields
                if (!isField(currentField.displayType) && !isGroup(currentField.displayType)) {
                  throw new Error(`${noticeType} | Element ${currentField.displayType} non attendu :(GROUP|FIELD) est attendu`);
                }
                if (isField(currentField.displayType)) {
                  sectionGroup.fields.push(NoticeFactory.createField(currentField));
                }

                if (isGroup(currentField.displayType)) {
                  let nbSubGrp = 0;
                  const sectionSubGroup: SubGroup = NoticeFactory.createSubGroup(currentField);
                  const currentSubGroup = currentField.content;
                  for (let currentsSubGroupId in Object.keys(currentSubGroup)) {
                    let currentField = currentSubGroup[currentsSubGroupId];
                    sectionSubGroup.fields.push(NoticeFactory.createField(currentField));
                  }
                  sectionGroup.subGroups.push(sectionSubGroup);
                }
              }
              section.groups.push(sectionGroup);
            } else {
              this.LOG.debug(`${noticeType} | [SECTION ${sectionNumber} | FIELD ${fieldnNumber} ] : ${currentSectionElement.id}`);
              section.fields.push(NoticeFactory.createField(currentSectionElement));
            }
          }
        }
        notice.sections.push(section);
      }
    }
    this.LOG.debug('NOTICE', notice);
    return notice;
  }

}
